<template>
  <div class="pos-cobro d-flex flex-column">

    <!-- Zona scrollable -->
    <div class="pc-scroll">

    <!-- Config compacta -->
    <div class="pc-card">
      <div class="row g-2">
        <div class="col-6">
          <label class="field-lbl">TIPO DOC</label>
          <select class="cobro-sel" v-model="idserie">
            <option v-for="s in series" :key="s.idserie" :value="s.idserie">{{ s.abrev }} - {{ s.serie }}</option>
          </select>
        </div>
        <div class="col-6">
          <label class="field-lbl">ALMACÉN</label>
          <select class="cobro-sel" :value="idalmacen" @change="$emit('almacen-change', +$event.target.value)">
            <option value="1">A. Lapoint 939</option>
            <option value="15">A. Lapoint 1179</option>
          </select>
        </div>
        <div class="col-6">
          <label class="field-lbl">CONDICIÓN</label>
          <select class="cobro-sel" v-model="idcondicion">
            <option :value="1">Contado</option>
            <option :value="6">Crédito</option>
          </select>
        </div>
        <div v-if="idcondicion === 6" class="col-6">
          <label class="field-lbl">DÍAS CRÉDITO</label>
          <input type="number" min="1" max="365" v-model.number="ndiasvenc"
            class="cobro-input text-center fw-bold" placeholder="30" />
        </div>
        <div :class="idcondicion === 6 ? 'col-12' : 'col-6'">
          <label class="field-lbl">VENDEDOR</label>
          <select class="cobro-sel" v-model="idvendedor">
            <option v-for="v in vendedores" :key="v.id" :value="v.id">{{ v.nombre }}</option>
          </select>
        </div>
      </div>

      <!-- Cliente -->
      <div class="position-relative mt-2 pt-2" style="border-top:1px solid #eef1f4">
        <label class="field-lbl">CLIENTE</label>

        <div v-if="clienteSeleccionado" class="d-flex align-items-center justify-content-between cliente-chip">
          <div class="d-flex align-items-center gap-2 min-w-0">
            <div class="cli-avatar">{{ (clienteSeleccionado.nombre || '?').slice(0,2).toUpperCase() }}</div>
            <div class="min-w-0">
              <div class="cli-name">{{ clienteSeleccionado.nombre }}</div>
              <div class="cli-doc">{{ clienteSeleccionado.nrodoc }}</div>
            </div>
          </div>
          <button @click="limpiarCliente" class="cli-x">✕</button>
        </div>

        <template v-else>
          <div class="d-flex gap-2 align-items-center">
            <div class="flex-grow-1 position-relative">
              <input
                v-model="clienteBusqueda"
                @input="onClienteInput"
                @blur="cerrarClienteDrop"
                @focus="clienteResultados.length && (mostrarClienteDrop=true)"
                type="text"
                class="cobro-input"
                placeholder="Buscar por nombre o DNI/RUC…"
              />
              <div v-if="mostrarClienteDrop && clienteResultados.length" class="cliente-drop">
                <div v-for="c in clienteResultados" :key="c.idpersona"
                  class="drop-item-cli"
                  @mousedown.prevent="seleccionarCliente(c)">
                  <div class="cli-name">{{ c.nombre }}</div>
                  <div class="cli-doc">{{ c.nrodoc }}</div>
                </div>
              </div>
            </div>
            <button @click="mostrarNuevoCliente=true" class="cli-nuevo-btn" title="Nuevo cliente">
              + Nuevo
            </button>
          </div>
          <div class="cli-hint">Sin cliente = se registra como VARIOS</div>
        </template>
      </div>
    </div>

    <!-- Modal nuevo cliente -->
    <ClienteModal v-if="mostrarNuevoCliente"
      @cerrar="mostrarNuevoCliente=false"
      @cliente-creado="onClienteCreado"
    />

    <!-- Resumen / TOTAL -->
    <div class="pc-card" :class="esGratuita ? 'is-gratis' : ''">
      <div v-if="hayDescuento && !esGratuita" class="d-flex justify-content-between align-items-center resumen-row">
        <span class="resumen-lbl">Precio etiqueta</span>
        <span class="text-decoration-line-through resumen-etq">S/ {{ totalCarrito.toFixed(2) }}</span>
      </div>

      <div v-if="!esGratuita" class="mb-2">
        <div class="d-flex gap-2 align-items-end">
          <div class="flex-grow-1">
            <label class="field-lbl">COBRAR (S/)</label>
            <input type="number" min="0" step="0.10"
              v-model="montoFijoStr"
              @change="onMontoFijoInput"
              @focus="montoFijoStr = totalFinal > 0 ? totalFinal.toFixed(2) : ''"
              class="cobro-input fw-bold text-end big-input"
              :placeholder="totalFinal > 0 ? totalFinal.toFixed(2) : '0.00'"
            />
          </div>
          <div style="width:72px;flex-shrink:0">
            <label class="field-lbl">DSC %</label>
            <input type="number" min="0" max="100" step="1"
              :value="dscGlobal || ''"
              @input="onDscGlobalInput"
              class="cobro-input text-center fw-bold"
              placeholder="0"
            />
          </div>
        </div>
        <div v-if="hayDescuento" class="text-end mt-1 resumen-dsc">
          descuento: − S/ {{ montoDescuento.toFixed(2) }}
        </div>
      </div>

      <div class="total-block text-center">
        <div class="total-lbl">TOTAL A COBRAR</div>
        <div class="total-val" :class="esGratuita || hayDescuento ? 'is-green' : 'is-blue'">
          {{ esGratuita ? 'S/ 0.00' : 'S/ ' + totalFinal.toFixed(2) }}
        </div>
      </div>

      <div class="text-center">
        <div class="form-check d-inline-flex align-items-center gap-2">
          <input class="form-check-input" type="checkbox" id="chkGratuita" v-model="esGratuita" style="width:16px;height:16px;cursor:pointer" />
          <label class="form-check-label gratis-lbl" for="chkGratuita">Venta Gratuita / Obsequio</label>
        </div>
      </div>
    </div>

    <!-- Forma de pago -->
    <div class="pc-card">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="field-lbl mb-0">FORMA DE PAGO</label>
        <span v-if="pagosAgregados.length > 0" class="pago-status">
          S/ {{ totalPagado.toFixed(2) }}
          <span v-if="pendientePago > 0" class="text-danger"> · Falta S/ {{ pendientePago.toFixed(2) }}</span>
          <span v-else class="text-success"> · ✓ Completo</span>
        </span>
      </div>

      <div v-for="(p, i) in pagosAgregados" :key="i" class="d-flex align-items-center gap-2 mb-1">
        <span class="pago-chip">{{ p.nombre }}</span>
        <span class="pago-monto">S/ {{ p.importe.toFixed(2) }}</span>
        <button @click="quitarPago(i)" class="pago-x">✕</button>
      </div>

      <div v-if="pendientePago > 0 || pagosAgregados.length === 0" class="d-flex gap-2 align-items-center" :class="pagosAgregados.length ? 'mt-2' : ''">
        <select v-model="idformaNueva" class="cobro-sel" style="flex:1;min-width:0">
          <option v-for="f in formasDisponibles" :key="f.idforma" :value="f.idforma">{{ f.nombre }}</option>
        </select>
        <input type="number" v-model.number="importeNuevo" min="0" step="0.10"
          class="cobro-input text-end fw-bold" style="width:90px;flex-shrink:0" placeholder="S/" />
        <button @click="agregarPago" class="pago-add">+ Agregar</button>
      </div>
    </div>

    <!-- Calculadora (solo cuando hay efectivo en los pagos) -->
    <div v-if="!esGratuita && tieneEfectivo" class="pc-card">
      <label class="field-lbl">PAGA CON</label>
      <input
        type="text" readonly
        :value="pagaCon || ''"
        class="cobro-input text-end fw-bold paga-input"
        placeholder="0.00"
      />
      <div class="numpad-grid">
        <button v-for="k in numpadKeys" :key="k" class="numpad-btn" @click="numpadPress(k)">
          <span v-if="k === '←'">⌫</span>
          <span v-else>{{ k }}</span>
        </button>
      </div>
      <div v-if="vuelto !== null" class="mt-2 d-flex justify-content-between align-items-center vuelto-row"
        :class="vuelto < 0 ? 'is-neg' : 'is-pos'">
        <span class="vuelto-lbl">VUELTO</span>
        <span class="vuelto-val">S/ {{ Math.max(0, vuelto).toFixed(2) }}</span>
      </div>
    </div>

    </div><!-- fin zona scrollable -->

    <!-- Botones fijos al fondo -->
    <div class="pc-footer d-flex gap-2">
      <button
        class="cobrar-btn"
        :disabled="!puedeVender || cargando"
        @click="cobrar">
        <span v-if="cargando" class="spinner-border spinner-border-sm me-2"></span>
        {{ cargando ? 'PROCESANDO...' : (esGratuita ? 'REGISTRAR OBSEQUIO' : 'COBRAR') }}
      </button>
      <button v-if="carrito.length" class="cancelar-btn" @click="$emit('limpiar')" title="Cancelar venta">
        Cancelar
      </button>
    </div>

  </div>
</template>

<script>
import api from '../../../services/api';
import { getUser } from '../../../services/authService';
import ClienteModal from './ClienteModal.vue';

const ID_CLIENTE_GENERICO = 5819;

export default {
  name: 'PosCobro',
  components: { ClienteModal },
  props: {
    carrito:   { type: Array, required: true },
    series:    { type: Array, default: () => [] },
    idalmacen: { type: Number, default: 1 },
  },
  emits: ['limpiar', 'venta-registrada', 'almacen-change'],
  data() {
    return {
      idserie: null, idcondicion: 1, idvendedor: null, ndiasvenc: 30, idcuadrecaja: null,
      pagosAgregados: [],
      idformaNueva: 1,
      importeNuevo: 0,
      formasDisponibles: [],
      pagaCon: '',
      esGratuita: false,
      dscGlobal: 0,
      montoFijoStr: '',
      cargando: false,
      vendedores: [],
      clienteBusqueda: '', clienteResultados: [], clienteSeleccionado: null, mostrarClienteDrop: false, clienteTimer: null, mostrarNuevoCliente: false,
      numpadKeys: ['7','8','9','4','5','6','1','2','3','.','0','←'],
      formas: [{ id: 1, label: 'Efectivo' }, { id: 2, label: 'Tarjeta' }, { id: 3, label: 'Transferencia' }],
      tarjetas: ['Visa', 'Master', 'Amex', 'Diners'],
    };
  },
  computed: {
    totalCarrito() { return this.carrito.reduce((s, i) => s + (i.precFinal || 0) * (i.cantidad || 1), 0); },
    montoDescuento() { return this.totalCarrito * ((this.dscGlobal || 0) / 100); },
    totalFinal() { return Math.max(0, this.totalCarrito - this.montoDescuento); },
    hayDescuento() { return (this.dscGlobal || 0) > 0; },
    totalPagado() { return this.pagosAgregados.reduce((s, p) => s + p.importe, 0); },
    pendientePago() { return Math.max(0, parseFloat((this.totalFinal - this.totalPagado).toFixed(2))); },
    tieneEfectivo() { return this.pagosAgregados.some(p => p.idforma === 1); },
    vuelto() {
      if (!this.tieneEfectivo || !this.pagaCon) return null;
      const efectivo = this.pagosAgregados.find(p => p.idforma === 1);
      const montoEfectivo = parseFloat(this.pagaCon) || (efectivo?.importe || 0);
      return montoEfectivo - (efectivo?.importe || 0) + (this.totalPagado - this.totalFinal);
    },
    puedeVender() {
      return this.carrito.length > 0 && this.idserie && this.idvendedor &&
        (this.esGratuita || this.pagosAgregados.length > 0);
    },
  },
  watch: {
    series: { immediate: true, handler(val) { if (val.length && !this.idserie) this.idserie = val[0].idserie; } },
    carrito: {
      deep: true,
      handler() { this.dscGlobal = 0; this.montoFijoStr = ''; },
    },
    idformaNueva() {
      this.importeNuevo = this.pendientePago > 0 ? this.pendientePago : this.totalFinal;
    },
  },
  mounted() { this.cargarVendedores(); this.cargarFormas(); this.cargarCajaActiva(); },
  methods: {
    async cargarVendedores() {
      try {
        const res = await api.get('/vendedores');
        this.vendedores = (res.data.data || []).map(v => ({ id: v.idpersona, nombre: v.nombre || v.usuario }));
        const user = getUser();
        if (user && !this.idvendedor) {
          const yo = this.vendedores.find(v => v.id === user.id);
          if (yo) this.idvendedor = yo.id;
          else if (this.vendedores.length) this.idvendedor = this.vendedores[0].id;
        }
      } catch { this.vendedores = []; }
    },
    async cargarCajaActiva() {
      try {
        const res = await api.get('/catalogo/caja-activa');
        this.idcuadrecaja = res.data.data?.idcuadrecaja || null;
      } catch { this.idcuadrecaja = null; }
    },
    async cargarFormas() {
      try {
        const res = await api.get('/catalogo/formas-pago');
        this.formasDisponibles = res.data.data || [];
      } catch {
        this.formasDisponibles = [
          { idforma: 1, nombre: 'Efectivo' }, { idforma: 2, nombre: 'VISA' },
          { idforma: 3, nombre: 'MASTERCARD' }, { idforma: 5, nombre: 'YAPE/BCP' },
          { idforma: 6, nombre: 'PLIN' }, { idforma: 7, nombre: 'Transferencia' },
        ];
      }
      if (this.formasDisponibles.length) this.idformaNueva = this.formasDisponibles[0].idforma;
    },
    agregarPago() {
      if (!this.idformaNueva || !this.importeNuevo || this.importeNuevo <= 0) return;
      const forma = this.formasDisponibles.find(f => f.idforma === this.idformaNueva);
      // Si ya existe esa forma, actualizar importe
      const existing = this.pagosAgregados.find(p => p.idforma === this.idformaNueva);
      if (existing) { existing.importe = parseFloat(this.importeNuevo); }
      else { this.pagosAgregados.push({ idforma: this.idformaNueva, nombre: forma.nombre, importe: parseFloat(this.importeNuevo) }); }
      this.idformaNueva = null;
      this.importeNuevo = 0;
    },
    quitarPago(i) { this.pagosAgregados.splice(i, 1); },
    onMontoFijoInput() {
      const monto = parseFloat(this.montoFijoStr);
      if (isNaN(monto) || monto <= 0) { this.dscGlobal = 0; return; }
      const total = this.totalCarrito;
      if (monto >= total) { this.dscGlobal = 0; this.montoFijoStr = ''; return; }
      this.dscGlobal = parseFloat(((1 - monto / total) * 100).toFixed(2));
    },
    onDscGlobalInput(e) {
      const v = parseFloat(e.target.value);
      this.dscGlobal = isNaN(v) ? 0 : Math.min(100, Math.max(0, v));
    },
    numpadPress(k) {
      if (k === '←') { this.pagaCon = this.pagaCon.slice(0, -1); return; }
      if (k === '.' && this.pagaCon.includes('.')) return;
      if (this.pagaCon.length >= 8) return;
      this.pagaCon += k;
    },
    onClienteInput() {
      const q = this.clienteBusqueda.trim();
      if (q.length < 2) { this.clienteResultados = []; this.mostrarClienteDrop = false; return; }
      clearTimeout(this.clienteTimer);
      this.clienteTimer = setTimeout(() => this.buscarCliente(q), 300);
    },
    async buscarCliente(q) {
      try {
        const res = await api.get('/clientes', { params: { q, limit: 10 } });
        this.clienteResultados = res.data.data || [];
        this.mostrarClienteDrop = this.clienteResultados.length > 0;
      } catch { this.clienteResultados = []; }
    },
    seleccionarCliente(c) {
      this.clienteSeleccionado = { idpersona: c.idpersona, nombre: c.nombre, nrodoc: c.nrodoc };
      this.clienteBusqueda = '';
      this.clienteResultados = [];
      this.mostrarClienteDrop = false;
    },
    onClienteCreado(c) {
      this.clienteSeleccionado = { idpersona: c.idpersona, nombre: c.nombre, nrodoc: c.nrodoc };
      this.mostrarNuevoCliente = false;
    },
    limpiarCliente() { this.clienteSeleccionado = null; this.clienteBusqueda = ''; },
    cerrarClienteDrop() { setTimeout(() => { this.mostrarClienteDrop = false; }, 150); },
    async cobrar() {
      if (!this.puedeVender || this.cargando) return;
      this.cargando = true;
      try {
        const dsc = (this.dscGlobal || 0) / 100;
        const payload = {
          idserie:           this.idserie,
          idalmacen:         this.idalmacen,
          tipodestino:       1,
          iddestino:         this.clienteSeleccionado?.idpersona || ID_CLIENTE_GENERICO,
          idtipomov:         3,
          fecha_emision:     new Date().toISOString().slice(0, 10),
          montototdoc:       this.totalFinal,
          iddirfactura:      1,
          iddirguia:         1,
          idvendedor:        this.idvendedor,
          idtipotransaccion: this.idcondicion === 6 ? 6 : 1,
          ndiasvenc:         this.idcondicion === 6 ? (this.ndiasvenc || 30) : 0,
          gratuito:          this.esGratuita,
          idcuadrecaja:      this.idcondicion !== 6 ? (this.idcuadrecaja || undefined) : undefined,
          formas_pago:       this.esGratuita ? [] : this.pagosAgregados.map(p => ({ idforma: p.idforma, importe: p.importe })),
          items: this.carrito.map(i => ({
            idpres:   i.idpres,
            cantidad: i.cantidad,
            precio:   this.esGratuita ? 0 : parseFloat((i.precFinal * (1 - dsc)).toFixed(4)),
            tipoprod: 1,
          })),
        };
        const res = await api.post('/ventas', payload);
        const data = res.data.data || {};
        const comprobante = data.serie ? `${data.serie}-${String(data.numero).padStart(7,'0')}` : 'OK';
        this.$emit('venta-registrada', { comprobante });
        this.$emit('limpiar');
        this.pagaCon = '';
        this.pagosAgregados = [];
        this.idformaNueva = this.formasDisponibles[0]?.idforma || 1;
        this.importeNuevo = 0;
        this.clienteSeleccionado = null;
        this.clienteBusqueda = '';
        this.clienteResultados = [];
        this.esGratuita = false;
        this.dscGlobal = 0;
      } catch (e) {
        alert('Error al registrar venta: ' + (e?.response?.data?.error || e.message));
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>

<style scoped>
.pos-cobro { height:100%; background:#f4f6f8; border-radius:12px; overflow:hidden; }
.pc-scroll { flex:1 1 0; overflow-y:auto; min-height:0; padding:10px; display:flex; flex-direction:column; gap:10px; scrollbar-width:thin; }

.pc-card { background:#fff; border:1px solid #e5e7eb; border-radius:12px; padding:12px; }
.pc-card.is-gratis { background:#ecfdf5; border-color:#a7f3d0; }
.min-w-0 { min-width:0; }

.field-lbl { display:block; font-size:10px; font-weight:700; letter-spacing:.6px; color:#94a3b8; margin-bottom:4px; }

.cobro-sel, .cobro-input {
  width:100%; height:36px; padding:0 10px; font-size:13px;
  background:#fff; color:#0f172a; border:1px solid #e5e7eb; border-radius:8px; outline:none; transition:.15s;
}
.cobro-sel:focus, .cobro-input:focus { border-color:#1d4ed8; box-shadow:0 0 0 3px rgba(29,78,216,.12); }
.cobro-input::placeholder { color:#cbd5e1; }
.big-input { height:44px; font-size:18px; }

/* Cliente */
.cliente-chip { background:#eff6ff; border:1px solid #dbeafe; border-radius:8px; padding:7px 10px; }
.cli-avatar { width:30px; height:30px; border-radius:50%; background:#1d4ed8; color:#fff; font-size:12px; font-weight:600; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.cli-name { font-size:13px; font-weight:600; color:#0f172a; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.cli-doc { font-size:11px; color:#94a3b8; }
.cli-x { background:none; border:none; color:#dc2626; font-size:15px; line-height:1; cursor:pointer; }
.cli-nuevo-btn { white-space:nowrap; flex-shrink:0; background:#eff5ff; color:#1d4ed8; border:1px solid #c7d7fb; border-radius:8px; padding:0 12px; height:36px; font-size:12px; font-weight:600; cursor:pointer; }
.cli-nuevo-btn:hover { background:#dbeafe; }
.cli-hint { font-size:11px; color:#94a3b8; margin-top:3px; }
.cliente-drop { position:absolute; left:0; right:0; top:calc(100% + 4px); z-index:300; background:#fff; border:1px solid #e5e7eb; border-radius:8px; box-shadow:0 8px 24px rgba(15,23,42,.12); max-height:220px; overflow-y:auto; }
.drop-item-cli { cursor:pointer; padding:8px 10px; border-bottom:1px solid #f4f6f8; }
.drop-item-cli:last-child { border-bottom:none; }
.drop-item-cli:hover { background:#eff5ff; }

/* Resumen / total */
.resumen-row { margin-bottom:6px; }
.resumen-lbl { font-size:12px; color:#64748b; }
.resumen-etq { font-size:14px; color:#94a3b8; }
.resumen-dsc { font-size:12px; color:#dc2626; }
.total-block { padding:6px 0 8px; }
.total-lbl { font-size:11px; color:#64748b; letter-spacing:.8px; font-weight:600; }
.total-val { font-weight:800; font-size:34px; line-height:1.1; }
.total-val.is-blue { color:#1d4ed8; }
.total-val.is-green { color:#16a34a; }
.gratis-lbl { font-size:13px; color:#059669; cursor:pointer; }

/* Formas de pago */
.pago-status { font-size:11px; color:#16a34a; }
.pago-chip { background:#eef2ff; color:#1d4ed8; font-size:11px; font-weight:600; padding:3px 8px; border-radius:6px; min-width:90px; text-align:center; }
.pago-monto { font-size:14px; font-weight:700; color:#0f172a; }
.pago-x { background:none; border:none; color:#dc2626; font-size:13px; cursor:pointer; margin-left:auto; }
.pago-add { white-space:nowrap; flex-shrink:0; background:#1d4ed8; color:#fff; border:none; border-radius:8px; padding:0 12px; height:36px; font-size:13px; font-weight:600; cursor:pointer; }
.pago-add:hover { background:#1e40af; }

/* Numpad */
.paga-input { height:44px; font-size:20px; letter-spacing:2px; cursor:default; margin-bottom:8px; }
.numpad-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:6px; }
.numpad-btn { background:#f8fafc; color:#0f172a; border:1px solid #e5e7eb; border-radius:8px; padding:10px; font-size:19px; font-weight:600; cursor:pointer; transition:background .1s; }
.numpad-btn:hover { background:#eef2ff; }
.numpad-btn:active { background:#dbeafe; }
.vuelto-row.is-pos { color:#16a34a; }
.vuelto-row.is-neg { color:#dc2626; }
.vuelto-lbl { font-size:13px; font-weight:600; }
.vuelto-val { font-size:22px; font-weight:900; }

/* Footer botones */
.pc-footer { padding:10px; background:#fff; border-top:1px solid #e5e7eb; flex-shrink:0; }
.cobrar-btn {
  flex:1; border:none; border-radius:10px; padding:14px; color:#fff; font-size:17px; font-weight:800; letter-spacing:.5px;
  background:#16a34a; cursor:pointer; transition:.15s; display:flex; align-items:center; justify-content:center;
}
.cobrar-btn:hover:not(:disabled) { background:#15803d; }
.cobrar-btn:disabled { opacity:.45; cursor:not-allowed; }
.cancelar-btn { flex-shrink:0; border:1px solid #fca5a5; background:#fff; color:#dc2626; border-radius:10px; padding:14px 18px; font-size:15px; font-weight:600; cursor:pointer; transition:.15s; }
.cancelar-btn:hover { background:#fef2f2; }
</style>
